export const styles = {
  mainWrapper: {
    position: "relative",
    maxWidth: "150px",
    margin: "0px auto",
  },
  iconWrapper: {
    position: "absolute",
    right: "12px",
    top: "10px",
    zIndex: "1",
  },
  staffUploadIcon: {
    width: "30px",
    height: "30px",
    borderRadius: "100%",
    border: "1px solid #f1f1f1",
    boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.12)",
    background: "#fff",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imagePreviewBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  imageWrapper: {
    position: "relative",
    width: "150px",
    height: "150px",
    borderRadius: "100%",
    border: "1px solid #e0e0e0",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    overflow: "hidden",
    transition: "all 0.2s ease-in-out",
  },
  changeImageLink: {
    cursor: "pointer",
    color: "#656565",
    fontSize: "12px",
    "&:hover": {
      color: "#1976d2",
      textDecoration: "underline",
    },
  },
  imageWrapperEmpty: {
    position: "relative",
    width: "150px",
    height: "150px",
    borderRadius: "100%",
    border: "2px solid #8a8d91",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
    transition: "all 0.2s ease-in-out",
    backgroundColor: "#d8dadf",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px",
    "&:hover": {
      backgroundColor: "#bcc0c4",
      borderColor: "#6b6e72",
    },
  },
};
